module.exports = __webpack_public_path__ + "files/299ab2ff3ee15efbef7d0eabd8c83abd.png";